"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _pushjs = require('push.js'); var _pushjs2 = _interopRequireDefault(_pushjs);
var _cookies = require('web/services/cookies');
var _amplitude = require('web/services/amplitude'); var _amplitude2 = _interopRequireDefault(_amplitude);

// The pushNotifSettings cookie: whether each user opted in on this machine.


// SAFETY: the cookie is written only below. readCookie gives null for a
// missing cookie; JSON.parse('null') is null, as JSON.parse(null) was.
const readPermissionsCookie = () =>
  JSON.parse(_nullishCoalesce(_cookies.readCookie.call(void 0, "pushNotifSettings"), () => ( 'null'))) 

// Return values - This is for the BROWSER PERMISSION
// NULL - We haven't asked yet
// FALSE - We asked and were declined
// TRUE - We asked and were accepted
 const hasBrowserPermission = () => {
  const perms = _pushjs2.default.Permission.get()

  if (perms === _pushjs2.default.Permission.DEFAULT) {
    return null
  } else if (perms === _pushjs2.default.Permission.GRANTED) {
    return true
  } else { // Push.Permission.DENIED
    return false
  }
}; exports.hasBrowserPermission = hasBrowserPermission

// Our LOCAL USER SETTING: notifications are on for this device unless the
// user turned them off in Settings.
 const getCookiePermission = (userKey) =>
  _optionalChain([readPermissionsCookie, 'call', _ => _(), 'optionalAccess', _2 => _2[userKey]]) !== false; exports.getCookiePermission = getCookiePermission

 const addUserCookiePermission = (userKey) => {
  let cookie = readPermissionsCookie()
  if (cookie == null) {
    cookie = {}
  }
  cookie[userKey] = true
  _cookies.createCookie.call(void 0, "pushNotifSettings", JSON.stringify(cookie), { years: 1 })
}; exports.addUserCookiePermission = addUserCookiePermission

 const removeUserCookiePermission = (userKey) => {
  const cookie = readPermissionsCookie() || {}
  cookie[userKey] = false
  _cookies.createCookie.call(void 0, "pushNotifSettings", JSON.stringify(cookie), { years: 1 })
}; exports.removeUserCookiePermission = removeUserCookiePermission

 const askForPermissionFunction = (success, fail) => {
  return _pushjs2.default.Permission.request(
    () => {
      _amplitude2.default.logEvent('notification_web_permission_granted')
      if (success) success()
    },
    () => {
      _amplitude2.default.logEvent('notification_web_permission_denied')
      if (fail) fail()
    },
  )
}; exports.askForPermissionFunction = askForPermissionFunction
